import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ENDPOINTS } from "@/api/application-api";
import { jsonAuthHeaders } from "@/utils/headers";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { useParams } from "react-router-dom";
import { useAuth } from "@/context/auth-context";
import { displayErrorToast } from "@/utils/toast";

export const useCreateProvider = ({ onSuccess }: { onSuccess: () => void }) => {
  const { workspaceId } = useParams();
  const auth = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (provider: {
      name: string;
      client: string;
      base_url: string;
      api_key: string;
    }) => {
      const response = await fetch(ENDPOINTS.providers(workspaceId as string), {
        method: "POST",
        body: JSON.stringify(provider),
        headers: jsonAuthHeaders(auth?.userToken!),
      });
      return handleResponse(response);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["providers"],
      });
      onSuccess();
    },
    onError: (error: Error) => {
      displayErrorToast(error);
    },
  });
};
